module.exports = "/images/assistance.jpg?8bcdc6a02fa8ce7eaea5a39dac55745c";